import React, { useState } from 'react';
import { Button, Input, Spin, Table, Alert } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import { ReportFilter, CurrencyItem } from '../../services/p1308Api';
import { useP1308Report } from './hooks/useP1308Report';

const P1308Report: React.FC = () => {
  const { loading, reportData, queried, noData, runQuery } = useP1308Report();

  const [codeStart, setCodeStart] = useState('');
  const [codeEnd, setCodeEnd] = useState('');

  const handleQuery = () => {
    const filter: ReportFilter = {
      code_start: codeStart || undefined,
      code_end: codeEnd || undefined,
    };
    runQuery(filter);
  };

  const columns: ColumnsType<CurrencyItem> = [
    {
      title: '幣別代號',
      dataIndex: 'code',
      key: 'code',
      align: 'center',
      width: 100,
    },
    {
      title: '中文名稱',
      dataIndex: 'name_zh',
      key: 'name_zh',
      ellipsis: true,
    },
    {
      title: '英文名稱',
      dataIndex: 'name_en',
      key: 'name_en',
      ellipsis: true,
    },
  ];

  return (
    <Spin spinning={loading}>
      <div className="max-w-3xl mx-auto p-4">
        <h2 className="text-xl font-bold mb-4">幣別清冊 (pw1308f1)</h2>

        {/* Filter Panel */}
        <div className="bg-gray-50 border border-gray-200 rounded p-4 mb-4">
          <div className="flex flex-wrap items-center gap-3 mb-3">
            <span className="text-sm font-medium w-16">幣別代號</span>
            <Input
              value={codeStart}
              onChange={e => setCodeStart(e.target.value.toUpperCase())}
              placeholder="起"
              style={{ width: 80 }}
              maxLength={3}
              onPressEnter={handleQuery}
            />
            <span className="text-sm">~</span>
            <Input
              value={codeEnd}
              onChange={e => setCodeEnd(e.target.value.toUpperCase())}
              placeholder="迄"
              style={{ width: 80 }}
              maxLength={3}
              onPressEnter={handleQuery}
            />
          </div>
          <div className="flex gap-2">
            <Button type="primary" icon={<SearchOutlined />} onClick={handleQuery}>
              查詢
            </Button>
          </div>
        </div>

        {/* Results */}
        {queried && !noData && reportData && (
          <div>
            <div className="mb-2 text-sm text-gray-500">
              共 {reportData.total} 筆幣別資料
            </div>
            <Table<CurrencyItem>
              dataSource={reportData.items}
              columns={columns}
              rowKey="code"
              size="small"
              pagination={false}
              bordered
              scroll={{ x: 400 }}
            />
          </div>
        )}

        {/* BR-P05: Empty result */}
        {queried && noData && (
          <Alert
            message="查無資料"
            description="查無符合條件的幣別資料!"
            type="info"
            showIcon
          />
        )}
      </div>
    </Spin>
  );
};

export default P1308Report;
